import { create } from 'zustand';
import { getCategories, type Category } from '@/services/matchingWeb.service';

interface CategoryStore {
    mainCategories: Category[];
    subCategories: Category[];
    isLoading: boolean;
    error: string | null;
    fetchAllCategories: () => Promise<void>;
    getCategoryById: (id: string) => Category | undefined;
    getSubCategoriesByMainId: (mainId: string) => Category[];
}

const useDDMCategoryStore = create<CategoryStore>((set, get) => ({
    mainCategories: [],
    subCategories: [],
    isLoading: false,
    error: null,
    fetchAllCategories: async () => {
        try {
            set({ isLoading: true, error: null });
            const [mainCategories, subCategories] = await Promise.all([getCategories(), getCategories('SUB')]);
            set({ mainCategories, subCategories, isLoading: false });
        } catch (error) {
            set({ error: (error as Error).message, isLoading: false });
        }
    },
    getCategoryById: (id) => {
        const { mainCategories, subCategories } = get();
        return mainCategories.find((c) => c.categoryId === id) || subCategories.find((c) => c.categoryId === id);
    },
    getSubCategoriesByMainId: (mainId) => {
        const { subCategories } = get();
        return subCategories.filter((c) => c.parentCategoryId === mainId);
    },
}));

export default useDDMCategoryStore;
